import classNames from 'classnames';
import { FC, useRef, useState } from 'react';
import ImageIcon from '~/assets/svgs/image.svg';
import { FileHelper } from '~/services/file';
import { convertFilesToImages } from '~/utils/converters';
import Button from '../Button';
import styles from './DropFiles.module.scss';

interface DropFilesProps {
    onDrop?: (files: IFile[]) => void;
    accept?: string;
    className?: string;
}

const DropFiles: FC<DropFilesProps> = ({ onDrop, accept = 'image/*, video/*', className }) => {
    const [hovered, setHovered] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setHovered(true);
    };

    const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setHovered(false);
    };

    const onDropFiles = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.dataTransfer.files.length === 0) return;

        const files = Array.from(e.dataTransfer.files).filter((file) => {
            if (FileHelper.fileChecking({ file })) {
                return file;
            }
        });
        const fileConverted = convertFilesToImages(files);
        onDrop?.(fileConverted);
    };

    const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []);

        if (files.length === 0) return;

        const fileConverted = convertFilesToImages(files);
        onDrop?.(fileConverted);
    };

    return (
        <div
            onDrop={onDropFiles}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            className={classNames(
                styles.drop_files,
                {
                    [styles.active]: hovered
                },
                className
            )}
            onClick={() => inputRef.current?.click()}
            onMouseDown={(e) => e.preventDefault()}
            onDragOver={(e) => e.preventDefault()}
        >
            <input
                type="file"
                multiple
                max={3}
                value=""
                className="hidden"
                ref={inputRef}
                accept={accept}
                onChange={handleChangeFile}
            />
            {/* <Icon name="document-upload" color={Colors.GREY_400} size={28} className="pointer-events-none" /> */}
            <div className="pointer-events-none w-full">
                {/* <Text type="body-3" color={Colors.GREY_800} className="inline">
                    Drop images here, or
                </Text>{' '}
                <Text type="label-4" color={Colors.GREY_800} className="inline">
                    Browse
                </Text> */}

                <Button style={{ width: '100%' }} variant="secondary">
                    <ImageIcon width={16} heigth={16} color="#fff" /> Add Photos{' '}
                </Button>
            </div>
        </div>
    );
};

export default DropFiles;
